/*
 * The image viewer of the docs galleries (.doc_gallery > a), in place of
 * lc_lightbox: the picture over a white page, arrows for the other pictures
 * of the same gallery, a counter and a close button. Keys: left, right, Esc.
 */
import './lightbox.css';

let box = null;
let image = null;
let counter = null;
let links = [];
let index = 0;
let opener = null;

function button(className, label, text, onClick) {
    const el = document.createElement('button');
    el.type = 'button';
    el.className = className;
    el.setAttribute('aria-label', label);
    el.textContent = text;
    el.addEventListener('click', (event) => {
        event.stopPropagation();
        onClick();
    });
    return el;
}

function build() {
    box = document.createElement('div');
    box.className = 'docs-lb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Image viewer');
    box.tabIndex = -1;

    image = document.createElement('img');
    image.className = 'docs-lb__img';
    image.alt = '';
    image.addEventListener('click', (event) => event.stopPropagation());

    counter = document.createElement('div');
    counter.className = 'docs-lb__count';

    box.appendChild(image);
    box.appendChild(counter);
    box.appendChild(button('docs-lb__btn docs-lb__close', 'Close', '×', close));
    box.appendChild(button('docs-lb__btn docs-lb__prev', 'Previous image', '‹', () => step(-1)));
    box.appendChild(button('docs-lb__btn docs-lb__next', 'Next image', '›', () => step(1)));

    // A click beside the picture closes the viewer
    box.addEventListener('click', close);
    box.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
        else if (event.key === 'ArrowLeft') step(-1);
        else if (event.key === 'ArrowRight') step(1);
        else if (event.key === 'Tab') {
            // Keep the focus inside the viewer
            const stops = Array.from(box.querySelectorAll('button')).filter((el) => el.offsetParent !== null);
            if (!stops.length) return;
            const first = stops[0];
            const last = stops[stops.length - 1];
            if (event.shiftKey && (document.activeElement === first || document.activeElement === box)) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }
    });

    document.body.appendChild(box);
}

function show() {
    const link = links[index];
    const thumb = link.querySelector('img');
    image.src = link.href;
    image.alt = (thumb && thumb.alt) || '';
    counter.textContent = links.length > 1 ? index + 1 + ' / ' + links.length : '';
    box.classList.toggle('docs-lb--single', links.length < 2);
}

function step(by) {
    if (links.length < 2) return;
    index = (index + by + links.length) % links.length;
    show();
}

function open(link) {
    const gallery = link.closest('.doc_gallery');
    links = Array.from(gallery.children).filter((el) => el.tagName === 'A' && el.getAttribute('href'));
    index = Math.max(0, links.indexOf(link));
    opener = link;

    if (!box) build();
    show();
    box.classList.add('docs-lb--open');
    document.documentElement.classList.add('docs-lb-lock');
    box.focus();
}

function close() {
    if (!box) return;
    box.classList.remove('docs-lb--open');
    document.documentElement.classList.remove('docs-lb-lock');
    image.removeAttribute('src');
    if (opener && opener.focus) opener.focus();
    opener = null;
}

/** Opens the viewer for a click on a picture of a gallery under `scope`. */
export function initLightbox(scope = '.docsContent .doc_gallery') {
    document.addEventListener('click', (event) => {
        // A click with a key held, or not the main button, opens the picture the browser's way
        if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest ? event.target.closest(scope + ' > a') : null;
        if (!link || !link.getAttribute('href')) return;
        event.preventDefault();
        open(link);
    });
}
